/* eslint-disable react/prop-types */ // TODO: add props
import { FormGroup, FormControl } from 'react-bootstrap';
import s from './styles.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

export const NumberAnswer = ({ question }) => {
  const fields = question.get('fields').toJS();
  const options = question.get('options').toJS();

  return (
    <div
      className={s.numberQuestion}
      data-test={`answer-${EXAM_QUESTION_TYPES.NUMBER}`}
    >
      <div className={s.question}>
        <FormGroup className={s.formGroup}>
          {fields?.map((field) => {
            const { prefix, suffix } = field;
            const correctOption = options.find((o) =>
              field.correct_options.includes(o.id)
            );
            const correctValue = correctOption?.value;

            return (
              <div key={field.id} className={s.inputWrapper}>
                {prefix && <span>{prefix}</span>}

                <FormControl
                  componentClass="input"
                  value={correctValue}
                  disabled
                />
                {suffix && <span>{suffix}</span>}
              </div>
            );
          })}
        </FormGroup>
        {/* 
        // TODO: re-enable correctness ui when we can calulate it correctly
        <span className={s.check} /> */}
      </div>
    </div>
  );
};
